'use client';
import { JumboConfigContextType } from 'themes/jumbo/@jumbo/types';
import React from 'react';

const defaultContextValue: JumboConfigContextType = {
  
};

const JumboConfigContext = React.createContext(defaultContextValue);

export { JumboConfigContext };
